import React, { useEffect, useRef, useState } from "react";
import status from "../../../../asset/images/Statustick.svg";
import uploadIcon from "../../../../asset/images/upload-file.svg";
import attachIcon from "../../../../asset/images/attachment-offmarket.svg";
import { Dealer_Mapping } from "../../../../Configuration/API_URL";
import {
  decryptData,
  formatDate,
  noDataFound,
  validateFile
} from "../../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import axiosInstance, { axiosFormDataInstance } from "../../../../CommonMethhods/axiosInstance";
import Loader from "../../../../Components/Common/Loader";
import closeIcon from "../../../../asset/images/close-gray.svg";
import SmallLoader from "../../../../Components/Common/smallLoader";
import infoIcon from "../../../../asset/images/info-circle.svg";


function ValidationResults({ validationData, setConfirmationData, onNext, isReadOnly,
  selectedRequest, refreshHistory, isFromMyRequest, setSelectedSR }) {
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [removedDoc, setRemovedDoc] = useState(false);
  const fileInputRef = useRef(null);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [docUploadLoader, setDocUploadLoader] = useState(false);
  // Set once the attach endpoint answers 409 (batch already submitted) or 501
  // (not enabled in this environment, e.g. prod) - retrying cannot succeed.
  const [attachUnavailable, setAttachUnavailable] = useState(false);

  const batchId = validationData?.batchId || selectedRequest?.batchId;


  const rowPreviewDetails = async () => {
    setLoader(true);

    try {
      const getDetails = await axiosInstance.get(
        `${Dealer_Mapping.validationRowPreview}/${batchId}`,
      );
      const decrypted = JSON.parse(
        decryptData(getDetails?.data)
      );

      if (decrypted?.status === 0) {
        console.log(decrypted, "rowTables");
        setRowData(decrypted?.data)

      } else {
        toast.error(decrypted?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if(batchId){
    rowPreviewDetails();
    }
  }, [batchId]);

  const hasSupportingDoc =
    (!!uploadedFile || !!rowData?.approvalDocLink) && !removedDoc;

  const canAttachDoc = !isReadOnly && !attachUnavailable;

  // Reopened drafts never went through the upload step, so the name comes from
  // the maker list item. It stays empty until SP_GET_MAKER_APPLICATIONS returns
  // it, and the summary simply leaves it out.
  const uploadedFileName =
    validationData?.fileName ||
    selectedRequest?.fileName ||
    rowData?.fileName ||
    "";

  // A re-upload of a sent back batch only updates the rows the checker sent
  // back - the backend lists the client codes it left unchanged.
  const skippedClientCodes = validationData?.skippedClientCodes || [];

  const summaryMeta = [
    uploadedFileName,
    `${validationData?.totalRows ?? 0} rows`,
  ]
    .filter(Boolean)
    .join(" · ");

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const attachSupportingDoc = async (file) => {
    if (!batchId) return;

    setDocUploadLoader(true);

    const formData = new FormData();
    // Dedicated attach endpoint: adds the document to a draft batch without
    // submitting it. The previous call reused /submit, which fell through to a
    // plain submit and discarded the document.
    formData.append("approval-doc", file);

    try {
      const url = `${Dealer_Mapping.singleMappingSubmit}/${batchId}/approval-doc`;
      const response = await axiosFormDataInstance.patch(url, formData);
      const decrypted = JSON.parse(decryptData(response?.data));

      if (decrypted?.status === 0) {
        toast.success(decrypted?.message);
        setUploadedFile(file);
        setRemovedDoc(false);
        // The response carries the signed link, so the rows need no refetch.
        setRowData((prev) => ({
          ...prev,
          approvalDocLink: decrypted?.data?.approvalDocLink,
          approvalDocFilename:
            decrypted?.data?.approvalDocFilename || file.name,
        }));
      } else {
        toast.error(decrypted?.message);
      }
    } catch (error) {
      const statusCode = error?.response?.status;

      // 501 means the endpoint is not enabled in this environment (prod until
      // SP_ATTACH_APPROVAL_DOC exists) - a deployment state, not a maker error.
      if (statusCode === 501) {
        setAttachUnavailable(true);
        toast.info(
          "Attaching a document is not available in this environment yet."
        );
        console.log(error);
        return;
      }

      // 409: the batch was already submitted, so there is nothing to attach to.
      if (statusCode === 409) {
        setAttachUnavailable(true);
      }

      let message = "Could not attach the document. Please retry.";

      try {
        message =
          JSON.parse(decryptData(error?.response?.data))?.message || message;
      } catch {
        // A 404 / 409 can come back without an encrypted body.
      }

      toast.error(message);
      console.log(error);
    } finally {
      setDocUploadLoader(false);
    }
  };

  const handleSupportingDocChange = (e) => {
    const file = e.target.files[0];
    e.target.value = "";

    if (!file || !validateFile(file)) return;

    attachSupportingDoc(file);
  };

  // const supportingDocName = uploadedFile?.name
  //   ? uploadedFile.name
  //   : rowData?.approvalDocLink
  //     ? decodeURIComponent(
  //       rowData.approvalDocLink
  //         .split("/")
  //         .pop()
  //         .split("?")[0]
  //     )
  //     : "";

  const handleSubmit = async () => {
    if (!validationData?.validRows || validationData.validRows === 0) {
      toast.error("No valid rows available to submit.");
      return;
    }
    setSubmitLoader(true);

    try {
      let url = "";
      let response;

      if (isFromMyRequest) {
        url = `${Dealer_Mapping.singleMappingSubmit}/${validationData?.batchId}/submit`;

        response = await axiosInstance.put(url);
      } else {
        url = `${Dealer_Mapping.singleMappingSubmit}/${validationData?.batchId}/submit`;

        response = await axiosInstance.put(url);
      }


      const decryptedresp = decryptData(response.data);
      const decrypted = JSON.parse(decryptedresp)

      console.log(decrypted, "decrypted");

      if (decrypted?.status === 0) {
        toast.success(decrypted.message);
        if (isFromMyRequest) {
          setSelectedSR(null);
          refreshHistory?.();
        } else {
          setConfirmationData({
            batchId: validationData?.batchId,
            type: "submit",
          });
          onNext();
        }
      } else {
        toast.error(decrypted.message);
      }
    } catch (error) {
      const decryptedResp = decryptData(error?.response?.data);
      const decryptedError = JSON.parse(decryptedResp);
      toast.error(decryptedError?.message)
      console.log(decryptedError);
    } finally {
      setSubmitLoader(false);
    }

  };


  return (
    <div className="wrap-preview-section">
      <div className="dl-map-table">
        <div className="dl-map-headers wrap-header-valid">
          {selectedRequest?.batchId ? 

              <div className="wrap-title-batch wrap-valid">
                <div className="status-content">
                  <span className="ckr-section-title">{selectedRequest?.batchId}</span>
                  {selectedRequest?.status !== "" ?
                    <span
                      className={`${selectedRequest.status.toLowerCase() === "pending" ? "status-pending" :
                        selectedRequest.status.toLowerCase() === "approved" ? "status-approved" :
                          selectedRequest.status.toLowerCase() === "rejected" ? "status-rejected" :
                            selectedRequest.status.toLowerCase() === "draft" ? "status-draft" :
                              selectedRequest.status.toLowerCase() === "sendback" ? "status-sendback" : ""
                        }`}>
                      {selectedRequest.status.toLowerCase() === "sendback" ? "Send Back" : selectedRequest?.status}
                    </span>
                    : "-"}
                </div>

              {!isReadOnly &&
                <div className="wrap-title">  
                  <p className="table-title valid-title">Validation Summary</p>
                  <p className="row-count">{summaryMeta}</p>
                </div>
              }
                </div>
                
                
                :
                !isReadOnly &&
                <>
                 <p className="table-title">Validation Summary</p>
                 <p className="row-count">{summaryMeta}</p>
                </>
                
              } 

        </div>
        {!isReadOnly &&
        <div className="valid-section">
          <div className="wrap-val">
            <label className="text-val">Total</label>
            <span>{validationData?.totalRows}</span>
          </div>

          <div className="wrap-val">
            <label className="text-val">Valid</label>
            <span>{validationData?.validRows}</span>
          </div>

          <div className="wrap-val">
            <label className="text-val">Invalid</label>
            <span>{validationData?.failedRows}</span>
          </div>

        </div>
        }

        {skippedClientCodes.length > 0 &&
          <div className="info-banner info-flex">
            <div className="wrap-infoicon">
              <img src={infoIcon} alt="info icon" />
            </div>
            <span className="banner-text">
              <span className="bold-text">
                {skippedClientCodes.length} row{skippedClientCodes.length > 1 ? "s were" : " was"} not changed:
              </span>{" "}
              {skippedClientCodes.join(", ")}
            </span>
          </div>
        }

        {validationData?.failedRows > 0 &&
          <>
            <div className="dl-map-headers">
              <p className="table-title">Row Errors</p>
            </div>


            <div className="err-wrapper">

              {validationData?.failedDetails?.map((item, index) => (
                <div className="err-card" key={index}>
                  <label className="err-title">{item.clientCode}</label>

                  {item.failures.map((failure, i) => (
                    <span key={i} className="missing-cont">
                      {failure}
                    </span>
                  ))}

                  {(item.reason || item.remarks) &&
                    <div className="err-meta">
                      {item.reason &&
                        <span className="err-meta-item">
                          <span className="err-meta-label">Category:</span> {item.reason}
                        </span>
                      }
                      {item.remarks &&
                        <span className="err-meta-item">
                          <span className="err-meta-label">Remarks:</span> {item.remarks}
                        </span>
                      }
                    </div>
                  }
                </div>
              ))}
            </div>
          </>
        }

      </div>

      <div className="dl-map-table">
        <div className="dl-map-headers">
          <p className="table-title">Row Preview</p>

          {rowData?.requests?.length > 0 && (hasSupportingDoc || canAttachDoc) &&
            <div className={`${hasSupportingDoc ?
              "wrap-upload-section doc-name disable-field" :
              "wrap-upload-section wrap-upload-red"}`}
              onClick={(e) => {
                e.stopPropagation();
                if (hasSupportingDoc || docUploadLoader || !canAttachDoc) return;
                handleUploadClick();
              }}
            >
              {hasSupportingDoc ?
                <img src={uploadIcon} alt="upload icon" /> :
                <img src={attachIcon} alt="attachment" />}

              <button
                className={`${hasSupportingDoc
                  ? "upload-doc-btn"
                  : "upload-doc-btn upload-doc-btn-red"
                  }`}
                   title={rowData?.approvalDocFilename}
                disabled={!hasSupportingDoc}
                onClick={(e) => {
                  if (hasSupportingDoc) {
                    e.preventDefault();
                    window.open(rowData.approvalDocLink, "_blank");
                  }
                }}
              >
                {docUploadLoader
                  ? <SmallLoader />
                  : rowData?.approvalDocFilename || "Upload supporting document"}
              </button>

              {/* {hasSupportingDoc && (
                <img
                  className="close"
                  src={closeIcon}
                  alt="close"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();

                    setUploadedFile(null);
                    setRemovedDoc(true);

                    if (fileInputRef.current) {
                      fileInputRef.current.value = "";
                    }
                  }}
                />
              )} */}
              <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,.png,.jpg"
                style={{ display: "none" }}
                onChange={handleSupportingDocChange}
              />
            </div>
          }
        </div>
        <div className="dlmap-table-wrapper">
          {loader ?
            <div className="loader-alignment">
              <Loader />
            </div>
            :
            <>
              {rowData?.requests && rowData?.requests?.length > 0 ?

                <table className="map-table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Request Date</th>
                      <th>Client Code</th>
                      <th>Client Name</th>
                      <th>Old Dealer Code</th>
                      <th>New Dealer Code</th>
                      <th>Effective Date</th>
                      <th>Reason for Change</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rowData?.requests.map((data, index) => (
                      <tr
                        key={data.id}
                        className={data?.id === data.id ? "ckr-active-row" : ""}
                      >
                        <td>{index + 1}</td>
                        <td>{formatDate(data?.reqDate) || "-"}</td>
                        <td>{data?.ucc || "-"}</td>
                        <td>{data?.clientName || "-"}</td>
                        <td>{data.oldDealerCode || "-"}</td>
                        <td>{data.newDealerCode || '-'}</td>
                        <td>{formatDate(data.startDate) || "-"}</td>
                        <td>{data?.reason}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                :
                <div className="step-content report-error-message">
                  {noDataFound()}
                </div>}
            </>
          }
        </div>
      </div>

      {validationData?.validRows > 0 &&
        <div
          className={`success-banner ${hasSupportingDoc ? "banner-doc-attached" : "banner-doc-pending"
            }`}
        >
          <img src={status} alt="status icon" />
          <span className="bold-text">{validationData?.validRows} valid rows ready.</span>
          {" "} Checker will receive email notification on submit.
          {!hasSupportingDoc &&
            " Since the supporting document is missing, upon submission this service request will be automatically saved as draft."}
        </div>
      }

      <div className="mapping-footer-actions">
        {!isReadOnly ?
        <>
        <button className="back-btn" onClick={() =>{
          if (isFromMyRequest) {
          setSelectedSR(null);
          refreshHistory?.();
        } else {
          setConfirmationData({
            batchId: validationData?.batchId,
            type: "draft",
          });
          onNext();
        }}}

        >Save as draft</button>
        {/* <button className="submit-btns"
          onClick={handleSubmit}> */}
        {/* Nothing valid means nothing to submit - the backend refuses it. */}
        <button className={`submit-btns ${!(validationData?.validRows > 0) ? "disabled-btn" : ""}`}
          onClick={handleSubmit}
          disabled={!(validationData?.validRows > 0) || submitLoader}>
          {submitLoader ?
            <SmallLoader />
            :
            validationData?.validRows > 0
              ? `Submit ${validationData.validRows} valid row${validationData.validRows > 1 ? "s" : ""}`
              : "Submit"
          }
        </button>
        </>
        :
        <button className="back-btn" 
          onClick={() => setSelectedSR(null)}
        >
          Cancel
        </button>
        }
        
      </div>

    </div>
  );
}

export default ValidationResults;
